import { GetAuthorizationUrlsApolloConnector } from '@front-activerse/common-components';
import ExternalProvider from './ExternalProvider';

const ExternalProviderContainer = ({
  returnUrl,
  action,
  displayAppleButton,
  displayFacebookButton,
  displayGoogleButton,
  socialBtnClassName,
  isCheckboxChecked = false,
}) => {
  return (
    <GetAuthorizationUrlsApolloConnector returnUrl={returnUrl} action={action}>
      {({ ...data }) => (
        <ExternalProvider
          {...data}
          displayFacebookButton={displayFacebookButton}
          displayGoogleButton={displayGoogleButton}
          displayAppleButton={displayAppleButton}
          action={action}
          socialBtnClassName={socialBtnClassName}
          isCheckboxChecked={isCheckboxChecked}
        />
      )}
    </GetAuthorizationUrlsApolloConnector>
  );
};

export default ExternalProviderContainer;
